export default __webpack_public_path__ + "a12b02e91513edea2bd74a8307e4acdc.png";